import { images } from "../../constants/images";
import { Helmet } from 'react-helmet-async';

const MetaDecoration = ({
    title = "Vende tu auto online sin comisión | Compra autos en Linze.",
    description = "Publica y vende tu auto online gratis. Somos el primer ecommerce car de Chile para comprar o vender autos usados y nuevos de forma rápida, segura y 100% digital",
    image = "https://res.cloudinary.com/gtt-dev/image/upload/v1681738556/metaImage_r5ausy.png",
    canonicalUrl,
    preloadImage,
    preloadImageMobile,
    keywords
}: {
    title?: string;
    description?: string;
    image?: string;
    canonicalUrl?: string;
    preloadImage?: string;
    preloadImageMobile?: string;
    keywords?: string;
}) => {
    const defaultDescription = "Publica y vende tu auto online gratis. Somos el primer ecommerce car de Chile para comprar o vender autos usados y nuevos de forma rápida, segura y 100% digital";
    const finalDescription = description && description.trim().length > 0 ? description : defaultDescription;

    // Inyectar meta tags en window para que el script en index.html los pueda leer
    if (typeof window !== 'undefined') {
        (window as any).__META_DESCRIPTION__ = finalDescription;
        (window as any).__META_TITLE__ = title;
        (window as any).__META_IMAGE__ = image;
        (window as any).__META_UPDATED__ = Date.now(); // Timestamp para detectar cambios
    }

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Linze",
        "url": "https://www.linzecar.cl",
        "description": "Publica y vende tu auto online gratis. Somos el primer ecommerce car de Chile para comprar o vender autos usados y nuevos de forma rápida, segura y 100% digital",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.linzecar.cl/buscar/autos/usados",
            "query-input": "required name=search_term_string"
        },
        "sameAs": [
            "https://www.facebook.com/Linzecar.chile/?locale=es_LA",
            "https://www.instagram.com/linzecar.chile/",
            "https://www.linkedin.com/company/linze-car/"
        ]
    };

    const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Linze",
        "url": "https://www.linzecar.cl",
        "logo": "https://www.linzecar.cl/static/media/logotipo.a7640e9b9d6c517da90a1af15d75068d.svg",
        "description": "Publica y vende tu auto online gratis. Somos el primer ecommerce car de Chile para comprar o vender autos usados y nuevos de forma rápida, segura y 100% digital",
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "CL",
            "addressRegion": "Región Metropolitana"
        }
    };

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={finalDescription} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:title" content={title} />

            <meta property="og:image" content={image} />
            <meta itemProp="image" content={image} />

            {/* Enhanced SEO meta tags */}
            <meta name="keywords" content={ keywords ? keywords : "autos usados chile, autos nuevos, comprar auto, vender auto, financiamiento automotriz, inspección vehicular" } />
            <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Linze" />

            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(organizationData)}
            </script>

            {/* Preload crítico para LCP - Hero Image */}
            {preloadImage && (
                <link
                    rel="preload"
                    as="image"
                    href={preloadImage}
                    imageSrcSet={`${preloadImage} 1920w`}
                    imageSizes="100vw"
                    media="(min-width: 551px)"
                    fetchPriority="high"
                />
            )}
            {preloadImageMobile && (
                <link
                    rel="preload"
                    as="image"
                    href={preloadImageMobile}
                    imageSrcSet={`${preloadImageMobile} 800w`}
                    imageSizes="100vw"
                    media="(max-width: 550px)"
                    fetchPriority="high"
                />
            )}
        </Helmet>
    );
}

export default MetaDecoration;